import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const TBTCOFOH_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/tbtcofoh/logo.png",
        alt: "Tomorrow Begins Today Consulting Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 23,
  state: "OH",
  departmentIds: [110, 123],
};
